module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAWlBMVEUAAAC1vMS2vMS2vcS2vMS1vMS2vMS2vcS1vMS2vcS1vMS2vMS2vcS1vMS1vMS1vMS2vMS2vcS2vMS1vMS1vMS2vcS2vcS2vcS2vcS2vcS2vcS1vMS1vMO1vMT8uFU+AAAAHXRSTlMAiO/jM/O9mmIt+thEGAm1cFNMPiDKrKOReBEPgCLrUWEAAADcSURBVEjH7dLJkoMgAEVRhBYZgvPUmvv/v9mmExephCpYJ3fh6p0qVMS3zy7MslzqDDAB6PS9hUbDkAw6sLvjmgxaCEJRJYOKUgjPkgwUze2xpu4NdCLAb+J+lKha9NCn7Qf1P13B9JejIcSW+7ZtY9dwP4viLPa1NI9Kc/93Z7GXOefVKI5q+/Po4vERoFsDr1duxUVAcXu8O6vPA5IqC1gwWcCATQbnTcwCEzoL1I4iCwzQZYEWQhaYUSILKOYomIriUE9dF2gjwPE+v0dAIY9Alk9z14zi2yf2B8c9GmLvZWM/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_agree_def.png
// module id = 621
// module chunks = 4 7